import { useEffect, useState } from "react";
import Button from "../../extras/Button";
import Pagination from "../../extras/Pagination";
import Table from "../../extras/Table";
import { useDispatch, useSelector } from "react-redux";
import { getPendingRequest, getUpdatePendingRequest } from "../../../redux/slice/productSlice";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { IconInfoCircle } from "@tabler/icons-react";
import MultiButton from "../../extras/MultiButton";

const RejectedProduct = () => {
    const dispatch = useDispatch();
    const [type, setType] = useState("Rejected");
    const [status, setStatus] = useState("New Items");
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [updateData, setupdateData] = useState([]);
    const { pendingReq, total, pendingUpdateReq } = useSelector((state) => state.product)
    const { setting } = useSelector((state) => state.setting)


    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event, 10));
        setPage(0);
    };

    useEffect(() => {
        if (status === "New Items") {
            dispatch(getPendingRequest(type));
            setData([]);
        } else {
            dispatch(getUpdatePendingRequest(type));
            setData([]);
        }
    }, [status, type, page, rowsPerPage])
    useEffect(() => {
        if (status === "New Items") {
            setData(pendingReq);
        } else {
            setupdateData(pendingUpdateReq);
        }
    }, [pendingReq]);
    const navigate = useNavigate();

    const handleInfoSettlement = (id) => {
        navigate("/admin/product/productTableDetails", {
            state: {
                id,
            },
        });
    };

    const mapData = [
        {
            Header: "No",
            width: "20px",
            Cell: ({ index }) => <span>{parseInt(index) + 1}</span>,
        },
        {
            Header: "Product",
            body: "image",
            Cell: ({ row }) => (
                <div className="d-flex ">
                    <div className="position-relative">


                        <img
                            src={row?.mainImage}
                            style={{ height: "50px", width: "50px", overflow: "hidden" }}
                            alt=""
                        />


                    </div>
                    <span className="ms-2 boxCenter">{row.productName}</span>
                </div>
            ),
        },

        { Header: "Product Code", body: "productCode" },

        {
            Header: `Price (${setting?.currencySymbol || "$"})`,
            body: "price",
            Cell: ({ row }) => (
                <span className=" text-dark">${row.price}</span>
            ),
        },
        {
            Header: "Shipping Charges",
            body: "shippingCharges",
            Cell: ({ row }) => <span>${row.shippingCharges}</span>,
        },

        {
            Header: "Created Date",
            body: "createdAt",
            Cell: ({ row }) => (
                <span>{dayjs(row.createdAt).format("DD MMM YYYY")}</span>
            ),
        },
        {
            Header: "Create Status",
            body: "status",
            Cell: ({ row }) => (

                <>
                    {status === "New Items" ? (
                        <span className=" badge-success " >
                            {row.createStatus}
                        </span>

                    ) : (
                        <span className=" badge-primary " >
                            {row.updateStatus}
                        </span>
                    )}
                </>

            ),
        },
        {
            Header: "Info",
            Cell: ({ row }) => (
                <div className="action-button">
                    <button
                        className="btn btn-sm"
                        onClick={() => handleInfoSettlement(row?._id)}
                    >
                        <IconInfoCircle className="text-secondary" />
                    </button>
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="userPage">
                <div className="multi-user-btn mb-3 ">
                    <MultiButton
                        multiButtonSelect={status}
                        setMultiButtonSelect={setStatus}
                        label={["New Items", "Updated Items"]}
                    />
                </div>
                 <div className="user-table mb-3">
                 <div className="user-table-top">
                        <div className=" d-flex justify-content-between align-items-center w-100 ">
                            <div className="w-100">
                                <h5
                                    className="main-title">
                                    Rejected Product
                                </h5>
                            </div>

                        </div>
                    </div>
                
                    {/* <div className="sellerHeader primeHeader">
                        <div className="row">
                            <div className="col-4 d-flex" id="">

                                <Button
                                    className={`bg-secondary m20-left p-10 mt-5 text-white`}
                                    text={`New Items`}
                                    style={{ padding: "9px 20px" }}
                                    onClick={() => setStatus("Create")}
                                />
                                <Button
                                    className={`bg-primary m20-left p-10 mt-5 text-white`}
                                    text={`Updated Items`}
                                    style={{ padding: "9px 20px" }}
                                    onClick={() => setStatus("Update")}
                                />
                            </div>
                        </div>
                    </div> */}
                   
                            {type == "Rejected" && (
                                <>
                                    <Table
                                        data={status === "Create" ? data : updateData}
                                        mapData={mapData}
                                        PerPage={rowsPerPage}
                                        Page={page}
                                        type={"client"}
                                    />
                                </>
                            )}
                            <Pagination
                                serverPage={page}
                                type={"server"}
                                onPageChange={handleChangePage}
                                setServerPage={setPage}
                                serverPerPage={rowsPerPage}
                                totalData={total}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                    
                
                 </div>
            </div>
        </>
    )
}
export default RejectedProduct;